const palette = {
    color_0_30_days: { // new projects
        background: "#9cce52",
        color: "#ffffff",
        border: "#9cce52"
    },
    color_pending: { // pending or other
        background: "#CDE3F8",
        color: "#ffffff",
        border: "#CDE3F8"
    },
    color_on_hold: { // on-hold
        background: "#998F3D",
        color: "#ffffff",
        border: "#998F3D"
    },
    color_60_90_days: { // assumed dead
        background: "#998F3D",
        color: "#ffffff",
        border: "#998F3D"
    },
    color_active: { // active
        background: "#FF6709",
        color: "#ffffff",
        border: "#FF6709"
    },
    color_30_60_days: { // languished
        background: "#0452A6",
        color: "#ffffff",
        border: "#0452A6"
    },
    color_90__days: {
        background: "#60605B",
        color: "#ffffff",
        border: "#60605B"
    },
    color_dead: { // dead
        background: "#60605B",
        color: "#ffffff",
        border: "#60605B"
    },
    color_declined: { // declined
        background: "#3163d6",
        color: "#ffffff",
        border: "#3163d6"
    },
    color_completed: { // completed
        background: "#FFAC4C",
        color: "#ffffff",
        border: "#FFAC4C"
    },

    ffbfe1: {
        background: "#ffbfe1",
        color: "#ffffff",
        border: "#ffbfe1"
    },
    f2bfff: {
        background: "#f2bfff",
        color: "#ffffff",
        border: "#f2bfff"
    },
    c8bfff: {
        background: "#c8bfff",
        color: "#ffffff",
        border: "#c8bfff"
    },
    bfd0ff: {
        background: "#bfd0ff",
        color: "#ffffff",
        border: "#bfd0ff"
    },
    bfe1ff: {
        background: "#bfe1ff",
        color: "#ffffff",
        border: "#bfe1ff"
    },
    bffbff: {
        background: "#bffbff",
        color: "#ffffff",
        border: "#bffbff"
    },
    bfffea: {
        background: "#bfffea",
        color: "#ffffff",
        border: "#bfffea"
    },
    bfffbf: {
        background: "#bfffbf",
        color: "#ffffff",
        border: "#bfffbf"
    },
    eaffbf: {
        background: "#eaffbf",
        color: "#ffffff",
        border: "#eaffbf"
    },
    fff2bf: {
        background: "#fff2bf",
        color: "#ffffff",
        border: "#fff2bf"
    },
    ffe1bf: {
        background: "#ffe1bf",
        color: "#ffffff",
        border: "#ffe1bf"
    },
    ffd0bf: {
        background: "#ffd0bf",
        color: "#ffffff",
        border: "#ffd0bf"
    },
    ffbfbf: {
        background: "#ffbfbf",
        color: "#ffffff",
        border: "#ffbfbf"
    },
    ff80b3: {
        background: "#ff80b3",
        color: "#ffffff",
        border: "#ff80b3"
    },
    ff80e5: {
        background: "#ff80e5",
        color: "#ffffff",
        border: "#ff80e5"
    },
    d580ff: {
        background: "#d580ff",
        color: "#ffffff",
        border: "#d580ff"
    },
    "9180ff": {
        background: "#9180ff",
        color: "#ffffff",
        border: "#9180ff"
    },
    c3ff80: {
        background: "#c3ff80",
        color: "#ffffff",
        border: "#c3ff80"
    },
    f6ff80: {
        background: "#f6ff80",
        color: "#ffffff",
        border: "#f6ff80"
    },
    ffe680: {
        background: "#ffe680",
        color: "#ffffff",
        border: "#ffe680"
    },
    ffc480: {
        background: "#ffc480",
        color: "#ffffff",
        border: "#ffc480"
    },
    ffb380: {
        background: "#ffb380",
        color: "#ffffff",
        border: "#ffb380"
    },
    ffa280: {
        background: "#ffa280",
        color: "#ffffff",
        border: "#ffa280"
    },
    ff8080: {
        background: "#ff8080",
        color: "#ffffff",
        border: "#ff8080"
    },
    ff0044: {
        background: "#ff0044",
        color: "#ffffff",
        border: "#ff0044"
    },
    ff0088: {
        background: "#ff0088",
        color: "#ffffff",
        border: "#ff0088"
    },
    ff00cc: {
        background: "#ff00cc",
        color: "#ffffff",
        border: "#ff00cc"
    },
    ee00ff: {
        background: "#ee00ff",
        color: "#ffffff",
        border: "#ee00ff"
    },
    aa00ff: {
        background: "#aa00ff",
        color: "#ffffff",
        border: "#aa00ff"
    },
    "0000ff": {
        background: "#0000ff",
        color: "#ffffff",
        border: "#0000ff"
    },
    "0044ff": {
        background: "#0044ff",
        color: "#ffffff",
        border: "#0044ff"
    },
    "0066ff": {
        background: "#0066ff",
        color: "#ffffff",
        border: "#0066ff"
    },
    "0088ff": {
        background: "#0088ff",
        color: "#ffffff",
        border: "#0088ff"
    },
    "00aaff": {
        background: "#00aaff",
        color: "#ffffff",
        border: "#00aaff"
    },
    "00ccff": {
        background: "#00ccff",
        color: "#ffffff",
        border: "#00ccff"
    },
    "00eeff": {
        background: "#00eeff",
        color: "#ffffff",
        border: "#00eeff"
    },
    "00ffcc": {
        background: "#00ffcc",
        color: "#ffffff",
        border: "#00ffcc"
    },
    "00ff88": {
        background: "#00ff88",
        color: "#ffffff",
        border: "#00ff88"
    },
    "00ff44": {
        background: "#00ff44",
        color: "#ffffff",
        border: "#00ff44"
    },
    "88ff00": {
        background: "#88ff00",
        color: "#ffffff",
        border: "#88ff00"
    },
    ccff00: {
        background: "#ccff00",
        color: "#ffffff",
        border: "#ccff00"
    },
    ffee00: {
        background: "#ffee00",
        color: "#ffffff",
        border: "#ffee00"
    }
}
palette.color_new = palette.color_0_30_days
palette.color_assumed_dead = palette.color_90__days
palette.color_languished = palette.color_30_60_days

let palette_index = 0
let shuffled_colors = null
let assigned_colors = {}

const array_shuffle = (array) => {
    for(let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
    }
    return array
}

const uses_color_palette = {
    methods: {
        assigned_color (identifier, color = null, shuffled = false) {
            if(!assigned_colors[identifier]) {
                if(!color) {
                    let colors = Object.keys(palette).filter(key => key !== "color_dead")
                    if(shuffled) {
                        if(!shuffled_colors) shuffled_colors = array_shuffle(colors)
                        colors = shuffled_colors
                    }
                    const index = (palette_index++) % colors.length
                    color = palette[colors[index]]
                } else palette_index++
                assigned_colors[identifier] = color
            }
            return assigned_colors[identifier]
        },
        forget_assigned_colors () {
            assigned_colors = {}
        },
        phase_color (phase) {
            const phase_palette = {
                sd: "#2196F3",
                dd: "#0D47A1",
                cd: "#3F51B5",
                ca: "#1A237E",
                incentives: "BF360C",
                other: "#000000"
            }
            const index = phase.toLowerCase()
            if(phase_palette[index]) return phase_palette[index]
            return "#CFD8DC"
        }
    },
    computed: {
        full_palette () {
            return [this.color_new, this.color_pending, this.color_on_hold, this.color_active, this.color_languished, this.color_dead, this.color_declined, this.color_completed]
        },
        extended_palette () {
            const extended_palette = { ...palette }
            delete extended_palette.color_dead
            return Object.values(extended_palette)
        },
        extra_colors () {
            const { color_assumed_dead, ...extra_colors } = palette
            return Object.values(extra_colors)
        }
    },
    data () {
        return {
            ...palette
        }
    }
}

export default uses_color_palette
